export default "__VITE_ASSET__DaYr4YIl__"